<div [hidden]="!menuEnabled">
  <div class="row mt-3">
    <div class="col-5 my-auto mx-auto bg-white p-3 rounded border border-primary">
      <div class="row">
        <div class="col-12 text-center">
          <h3 class="text-primary">กรุณาระบุ Email ที่ท่านใช้ในการลงทะเบียน</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <input type="text" class="form-control" [(ngModel)]="emailField">
            <span class="text-danger" *ngIf="submitted && emailField.trim() == ''">
              กรุณาระบุ Email ที่ท่านใช้ในการลงทะเบียน
            </span>
            <span class="text-danger" *ngIf="submitted && emailField.trim() != '' && !isValidMail">
              กรุณาระบุ Email ให้ถูกต้อง
            </span>
            <span class="text-danger" *ngIf="submitted && foundEmail == false && isValidMail">
              ไม่พบข้อมูลการลงทะเบียนของท่าน
            </span>
            <span class="text-success" *ngIf="submitted && foundEmail == true && isValidMail && resetType !='username'">
              ระบบได้ส่ง URL แจ้งรหัสผู้ใช้งาน ไปยัง {{emailField}} หากไม่พบ กรุณาค้นหาใน Spam Mail
            </span>
            <span class="text-success" *ngIf="submitted && foundEmail == true && isValidMail && resetType =='username'">
              ระบบได้ส่ง URL สำหรับกำหนดรหัสผ่านใหม่ ไปยัง {{emailField}} หากไม่พบ กรุณาค้นหาใน Spam Mail
            </span>
          </div>
        </div>
        <div class="col-12 text-center">
          <button type="button" class="btn btn-primary m-2" *ngIf="showOkBtn" (click)="checkEmail()">ตกลง</button>
        </div>
      </div>
    </div>
  </div>

</div>


// WEBPACK FOOTER //
// ./src/app/forgot-password/forgot-password.component.html